import React from 'react';
import PropTypes from 'prop-types';
import { isEmptyString } from 'utils/text';
import css from './HelpResources.scss';
import Icon from 'SF/MaterialIcon';
import { formatPhoneNumber } from 'utils/formatter';

/**
 * @returns {JSX.Element|null} the help desk phone number, if present
 */
function HelpPhone({ phone }) {
    if (isEmptyString(phone)) return null;
    return (
        <div className={css['helpdesk-item']}>
            <div className={css['helpdesk-icon']}>
                <Icon icon="phone" aria-hidden="true" />
            </div>
            <div className={css['helpdesk-element']}>
                <a href={`tel:${phone}`} className={css['links']} aria-label={`Call ${phone}`}>{formatPhoneNumber(phone)}</a>
            </div>
        </div>
    );
}

HelpPhone.propTypes = {
    phone: PropTypes.string
};

export default HelpPhone;
